/* unplugin-vue-components disabled */import { render } from "./headers.vue?vue&type=template&id=d2966e6e&scoped=true"
import script from "./headers.vue?vue&type=script&lang=js"
export * from "./headers.vue?vue&type=script&lang=js"

import "./headers.vue?vue&type=style&index=0&id=d2966e6e&lang=scss&scoped=true"

import exportComponent from "D:\\项目\\北国之春\\north\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2966e6e"]])

export default __exports__